/* eslint-disable @typescript-eslint/adjacent-overload-signatures */
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PorIconDirective } from '@por/shared/ui/icon-lib';
import { ApxControlChange } from '../models/change.model';
import { ApxControlDirective } from '../form/control.directive';

let nextCheckboxUniqueId = 0;

@Component({
    selector: 'apx-checkbox',
    standalone: true,
    imports: [CommonModule, PorIconDirective],
    templateUrl: './checkbox.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: ApxControlDirective,
            useExisting: forwardRef(() => ApxCheckboxComponent)
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ApxCheckboxComponent),
            multi: true
        }
    ]
})
export class ApxCheckboxComponent extends ApxControlDirective implements ControlValueAccessor, AfterViewInit {
    @ViewChild('checkboxContainer') checkboxContainer!: ElementRef;

    @Input() set checked(isChecked: boolean) {
        this.onChanged(isChecked);
        this.writeValue(isChecked);
    }
    @Input() set invalid(isInvalid: boolean) {
        this._isInvalid = isInvalid;
    }
    @Input() disabled = false;
    @Input() name = '';

    @Output() readonly valueChanged = new EventEmitter<ApxControlChange<boolean>>();
    @Output() readonly changed = new EventEmitter<{ source: string; value: string }>();

    private _isChecked = false;
    get checked() {
        return this._isChecked;
    }

    private _isInvalid = false;
    get invalid() {
        return this._isInvalid;
    }

    icon = {
        name: 'check',
        width: 14,
        height: 14
    };

    private readonly uniqueId = nextCheckboxUniqueId++;
    readonly inputId = `apx-checkbox-${this.uniqueId}`;
    readonly labelId = `apx-label-${this.uniqueId}`;

    // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-explicit-any
    onChanged: any = () => {};
    // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-explicit-any
    onTouched: any = () => {};

    ngAfterViewInit(): void {
        this.icon.width = this.checkboxContainer.nativeElement.offsetWidth - 2;
        this.icon.height = this.checkboxContainer.nativeElement.offsetHeight - 2;
    }

    writeValue(isChecked: boolean): void {
        this._isChecked = isChecked;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    registerOnChange(fn: any): void {
        this.onChanged = fn;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(disabled: boolean): void {
        this.disabled = disabled;
    }

    handleChange($event: Event) {
        this.onTouched(true);
        this.onChanged(($event.target as HTMLInputElement).checked);
        this.valueChanged.emit({
            value: ($event.target as HTMLInputElement).checked
        });
    }
}
